import type { TableHeadProps } from "@mui/material";
import { TableCell, TableHead, TableRow } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";

export const VersionsTableHead: FC<TableHeadProps> = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <TableHead {...props}>
      <TableRow className={styles["table-head-row"]}>
        <TableCell>{t("versioning.table_date_column")}</TableCell>
        <TableCell>{t("versioning.table_name_version_column")}</TableCell>
        <TableCell sortDirection={"desc"}>Ref</TableCell>
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );
};